export enum StatusCode {
  NotAcceptable = 406,
  Success = 200,
}
